var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex-grow-1"}),_c('CopyButton',{attrs:{"supplier-id":_vm.supplierId,"name":_vm.name}}),_c('EmailSupplierButton')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }